import BaseViewModel from "../../Core/BaseViewModel";

export default class ReturnPolicyViewModel extends BaseViewModel{
	loading: boolean = false;
	title: string = "";
	content: any = "";
}